const namedColors = <const>{
  blue: '#5d8ec3',
  green: '#aed581',
  yellow: '#ffd54f',
  salmon: '#e57373',
  purple: '#9575cd',
  pink: '#f48fb1',
  orange: '#ff7043',
  teal: '#4db6ac',
  brown: '#a1887f',
};

export const colors = Object.assign(Object.values(namedColors), namedColors);

export const traceBlue = '#2596be';
export const tracePurple = '#e748bc';
export const traceOlive = '#b4cd27';
export const traceOrange = '#ff7f0e';
export const _traceYellow = '#e5a929';
export const traceGreen = '#5ecd27';

const tracePatterns = <const>{
  'Write-Pending': traceBlue,
  'Front-End': traceGreen,
  'Back-End': traceOrange,
  'Seq Read': traceOlive,
  'Sequential Read': traceOlive,
  'Seq Write': tracePurple,
  'Sequential Write': tracePurple,
  Read: traceBlue,
  Write: traceOrange,
  'BE Rnd': traceBlue,
  'BE Seq': traceOlive,
  'BE C2D': traceOrange,
  sum: '#808080b3',
  Sum: '#808080b3',
  average: traceOlive,
};

export function getTraceColor(variant: string): string | undefined {
  for (const [pattern, color] of Object.entries(tracePatterns)) {
    if (variant.includes(pattern)) return color;
  }
}
